<template lang="pug">
  .navigate-car
    e-form.navigate-car__form(
      :formValidator="formValidator"
    )
      e-form-group(
        name="date_at"
        inputType="calendar"
        label="Дата"
        :model="model"
        type="date"
        tabView="tab1"
        @changeCalendar='changeCalendar'
      )
    label.label.semibold Гос. номер автомобиля
    input.input.navigate-car__input(
      type="search"
      placeholder="Гос. номер автомобиля"
      v-model="query"
      v-debounce:300="searchList"
    )
    ul.navigate-car__list.reset-list(
      v-if="park.length"
    )
      li.navigate-car__item(
        v-for="car in park" :key="'park'+car.id"
      )
        button.navigate-car__button.reset-btn(@click='selectCar(car)') {{car.brand}} {{car.model}} {{car.number}}

</template>

<script>
import { map as mapEndpoints, transport } from '@/api/api-endpoints'
import formBaseMixin from '@/components/form/form-base-mixin'
import L from 'leaflet'

const TIMEOUT_TO_REQUEST = 15000
const DEFAULT_ZOOM = 14

export default {
  name: 'navigate-car',
  mixins: [formBaseMixin],
  props: {
    map: {
      type: Object,
    },
  },
  data() {
    return {
      query: '',
      park: [],
      model: {
        date_at: '',
      },
      car: { id: '' },
      navigateLayer: null,
      objectsLayer: null,
      carIcon: null,
      carInterval: null,
      isCarUpdated: false,
      path: [],
      offset: 0,
    }
  },
  methods: {
    async searchList() {
      const query = this.query
      if (!query) {
        this.park = []
      } else {
        let data = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: transport.park({ query: { q: query } }),
          })
        ).data
        data = data.data
        this.park = data
      }
    },
    changeCalendar() {
      if (this.car.id) {
        this.offset = 0
        this.path = []
        if (this.carInterval) {
          clearInterval(this.carInterval)
        }
        this.drawCar(this.car.id)
        this.moveCar(this.car.id)
      }
    },
    selectCar(car) {
      this.car = car
      this.park = []
      this.query = car.number
      this.path = []
      this.offset = 0
      this.isCarUpdated = false
      if (this.model.date_at) {
        if (this.carInterval) {
          clearInterval(this.carInterval)
        }
        this.drawCar(this.car.id)
        this.moveCar(car.id)
      }
    },
    async drawCar(id) {
      this.$bar.start()
      if (this.navigateLayer) {
        this.map.removeLayer(this.navigateLayer)
      }
      let coords = null

      try {
        coords = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: transport.trackHistory(id, {
              query: {
                date_at: this.model.date_at,
                offset: this.offset,
              },
            }),
          })
        ).data
      } catch (e) {
        this.$notify.warning({
          title: e.data.message,
        })
      }
      if (coords && coords.length) {
        coords.forEach((v) => {
          this.path.push(L.latLng([v[0], v[1]]))
        })
      }
      if (!this.path.length) {
        if (this.carIcon) {
          this.map.removeLayer(this.carIcon)
        }
        if (this.carInterval) {
          clearInterval(this.carInterval)
        }
        this.$notify.warning({
          title: 'Данных за выбранный период нет',
        })
        return false
      }

      this.navigateLayer = new L.polyline(this.path, {
        color: 'red',
        weight: 3,
        opacity: 0.5,
        smoothFactor: 1,
      })
      this.map.addLayer(this.navigateLayer)
      if (!this.isCarUpdated) {
        this.map.setView(
          [
            this.path[this.path.length - 1].lat,
            this.path[this.path.length - 1].lng,
          ],
          DEFAULT_ZOOM
        )
        this.isCarUpdated = true
      }
      this.offset = this.path.length
      if (coords && coords.length) {
        this.drawCarIcon(coords[coords.length - 1])
      }
      this.$bar.finish()
    },
    async getObjects() {
      this.$store.commit('preloader', true)

      const objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: mapEndpoints.object(this.$route),
        })
      ).data
      let flatteredObjects = []
      Object.values(objects).forEach((v) => {
        flatteredObjects.push(...v)
      })

      this.objectsLayer = L.markerClusterGroup({
        showCoverageOnHover: false,
        iconCreateFunction: (cluster) =>
          L.divIcon({
            className: 'cluster-marker object',
            html: cluster.getChildCount(),
            iconSize: [36, 36],
            iconAnchor: [18, 18],
          }),
      })
      flatteredObjects.forEach((item) => {
        if (!item.lat || !item.lng) return
        const coords = [item.lat, item.lng]
        const myIcon = L.divIcon({
          className: 'my-div-icon',
          html: `<div class='map-icon map-icon_garbage map-icon_burial'></div>`,
        })
        const marker = L.marker(coords, {
          icon: myIcon,
        })
        marker.bindTooltip(item.name + '<br>' + item.address)
        this.objectsLayer.addLayer(marker)
      })
      this.map.addLayer(this.objectsLayer)
      this.$store.commit('preloader', false)
    },
    addContentToCarPopup(coords) {
      return `<div class='map-popup'>
                <div class="map-popup__header">
                    <div class="map-popup__title">${this.car.brand} ${
        this.car.model
      } ${this.car.number}</div>
                </div>
                <div class="map-popup__body">
                     <div class='map-popup__prop semibold'>Координаты:</div>
                     <div class='map-popup__value'>${coords[0]},${
        coords[1]
      }</div>
                     <div class='map-popup__prop semibold'>Дата и время:</div>
                     <div class='map-popup__value'>${coords[3]}</div>
                     <div style=${coords[2] ? '' : 'display:none'}>
                     <div class='map-popup__prop semibold'>Скорость:</div>
                     <div class='map-popup__value' >${coords[2]} км/ч</div>
                     </div>
                </div>
            </div>
        `
    },
    drawCarIcon(coords) {
      if (this.carIcon) {
        this.map.removeLayer(this.carIcon)
      }

      const className = 'navigate__car-icon'
      const myIcon = L.divIcon({
        className: 'navigate__car',
        iconAnchor: [20, 20],
        html: `<div class='${className}'><span class='navigate__car-point'></span></div>`,
      })
      this.carIcon = L.marker([coords[0], coords[1]], {
        icon: myIcon,
      })
      const popup = L.popup()
      popup.setContent(this.addContentToCarPopup(coords))
      this.carIcon.bindPopup(popup)
      this.map.addLayer(this.carIcon)
    },
    moveCar() {
      this.carInterval = setInterval(() => {
        this.drawCar(this.car.id)
      }, TIMEOUT_TO_REQUEST)
    },
  },
  created() {
    this.getObjects()
  },
  destroyed() {
    if (this.navigateLayer) {
      this.map.removeLayer(this.navigateLayer)
    }
    if (this.objectsLayer) {
      this.map.removeLayer(this.objectsLayer)
    }
    if (this.carInterval) {
      clearInterval(this.carInterval)
    }
  },
}
</script>

<style scoped lang="scss">
.navigate-car {
  padding: 10px;

  &__item + &__item {
    margin-top: 5px;
  }

  &__input,
  &__form {
    margin-bottom: 20px;
  }

  &__button {
    padding: 10px;
    text-align: left;
  }
}
</style>
